import { useLocation } from 'react-router-dom';
import { useCurrentOrg } from '../hooks/useCurrentOrg';
import { useStorageQuota } from '../hooks/useStorageFiles';
import { StorageQuotaFooter } from './Storage/StorageQuotaFooter';

function isFooterRoute(pathname: string): boolean {
  return pathname === '/' || pathname === '/dashboard' || pathname.startsWith('/storage');
}

/**
 * Application footer — shows storage quota on Dashboard and Storage pages.
 * Gate component prevents useStorageQuota from firing API calls on irrelevant pages.
 */
export function AppFooter() {
  const { currentOrg } = useCurrentOrg();
  const location = useLocation();

  if (!currentOrg || !isFooterRoute(location.pathname)) return null;

  return <AppFooterContent />;
}

function AppFooterContent() {
  const { data: quota, isLoading } = useStorageQuota();

  return (
    <footer
      role="contentinfo"
      aria-label="Application footer"
      className="sticky bottom-0 z-30 bg-white/80 dark:bg-zinc-800/80 backdrop-blur-md border-t border-default transition-colors"
    >
      <StorageQuotaFooter quota={quota} isLoading={isLoading} />
    </footer>
  );
}
